export function get_option_stack(data) {
    let option = {
        title: {
            top: "3",
            left: "center",
            text: "近3年的纳税额度趋势图",
            subtext: ""
        },
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data: ['纳税额'],
            top: 60
        },
        grid: {
            top: 90,
            show: true
        },
        toolbox: {
            feature: {
                dataView: {
                    show: true,
                    readOnly: false
                },
                magicType: {
                    show: true,
                    type: ['line', 'bar']
                },
                restore: {
                    show: true
                },
                saveAsImage: {}
            }
        },

        dataset: [{
            source: data
        }],
        xAxis: {
            type: 'category',
            boundaryGap: false
        },
        yAxis: [{
                type: 'value',
                name: '金额(元)',
                nameLocation: "middle",
                nameGap: 50
            }
           

        ],
        series: [{
                name: '纳税额',
                type: 'line',
                smooth: true,
                itemStyle: {normal: {areaStyle: {type: 'default'}}},
                // areaStyle: {},
                // emphasis: {
                //     focus: 'series'
                // },
                encode: {
                    x: 'ym',
                    y: 'diffTaxAmount'
                }
            },
          
            // {
            //     name: 'N₂O',
            //     type: 'line',
            //     smooth: true,
            //     encode: {
            //         x: 'time_of_data',
            //         y: 'N2O'
            //     },
            //     yAxisIndex: 1,
            // },

        ]
    };
    return option;
}


